import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba81187c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","height":"height: calc(100% - 64px)","overflow-y":"hidden","display":"flex","flex-direction":"column"} }
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { style: {"display":"block"} }
const _hoisted_4 = { style: {"padding":"8px"} }
const _hoisted_5 = ["onClick", "href"]
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = { style: {"display":"flex","flex-direction":"row","overflow-y":"hidden","height":"calc(100% - 30px)","min-width":"400px"} }
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column","overflow":"hidden"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Game "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Due Date "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" })
  ])
], -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Game "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Date ")
  ])
], -1))
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","overflow":"hidden","height":"calc(100% - 60px)"} }
const _hoisted_13 = { style: {"display":"block"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Game "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Value "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Action ")
  ])
], -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Please explain your full run including your route, bosses, completion percent, collectables and achivements you plan to do.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.closeInfo)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          style: {"margin-top":"15px","margin-left":"15px","margin-right":"15px","padding":"8px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, {
                  color: "rgba(0, 0, 0, 0)",
                  theme: "dark"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeInfo=true))
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Bounty Level ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_timeline, {
                density: "compact",
                size: "small",
                direction: "horizontal",
                "truncate-line": "start"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks, (rank, index) => {
                    return (_openBlock(), _createBlock(_component_v_timeline_item, {
                      size: "small",
                      key: index,
                      "dot-color": _ctx.getDotColor(index)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_menu, {
                            location: "end",
                            "close-on-content-click": false,
                            modelValue: _ctx.menu[rank],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.menu[rank]) = $event)
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(index + 1 === _ctx.bountyLevel? 'current-rank' : '')
                              }, [
                                _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props, { size: "x-small" }), {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(rank), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ], 2)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                color: "blue-grey-darken-4",
                                raised: "",
                                dark: "",
                                cover: "",
                                "min-width": "300"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_tabs, {
                                    modelValue: _ctx.tab[rank],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.tab[rank]) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tab, { value: "Perks" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Perks ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_tab, { value: "Requirements" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Requirements ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_v_divider),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_window, {
                                        modelValue: _ctx.tab[rank],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.tab[rank]) = $event)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_window_item, { value: "Perks" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, null, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perks[rank], (perk) => {
                                                    return (_openBlock(), _createBlock(_component_v_list_item, { key: perk }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(perk), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_window_item, { value: "Requirements" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, null, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requirements[rank], (req) => {
                                                    return (_openBlock(), _createBlock(_component_v_list_item, { key: req }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(req), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["dot-color"]))
                  }), 128))
                ]),
                _: 1
              }),
              (_ctx.loaded && _ctx.isBountyMember())
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    style: {"margin-bottom":"15px","margin-left":"15px","margin-right":"15px","margin-top":"15px","padding":"8px","overflow-y":"hidden","flex":"1"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Promotion Requirements")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_list, {
                          density: "compact",
                          size: "x-small"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                density: "compact",
                                size: "x-small",
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    (task.link)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.completeTask(task)),
                                          target: "_blank",
                                          href: task.link,
                                          class: _normalizeClass(task.completed? 'completed': '')
                                        }, _toDisplayString(task.name), 11, _hoisted_5))
                                      : _createCommentVNode("", true),
                                    (!task.link)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass(task.completed? 'completed': '')
                                        }, _toDisplayString(task.name), 3))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.canPromote(),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.promoteBountyLevel();}),
                            color: "green",
                            variant: "tonal",
                            elevation: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Promote")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loaded && _ctx.loggedIn && !_ctx.isBountyMember())
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          style: {"margin-bottom":"15px","margin-left":"15px","margin-right":"15px","margin-top":"15px","padding":"8px","overflow-y":"hidden","flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Join the bounty program")
              ]),
              _: 1
            }),
            (_ctx.bountyProgramError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.bountyProgramError), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.joinBountyProgram()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Join")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loaded && _ctx.loggedIn && _ctx.isBountyMember())
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 2,
          style: {"margin-bottom":"15px","margin-left":"15px","margin-right":"15px","margin-top":"15px","padding":"8px","overflow-y":"hidden","flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Bounty Info")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_card, {
                  color: "blue-grey-darken-4",
                  raised: "",
                  dark: "",
                  cover: "",
                  style: {"flex":".8","margin":"8px","padding":"5px","overflow":"hidden"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Active Bounties")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_table, {
                      density: "compact",
                      height: "300px",
                      style: {"overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reserved, (bounty) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: bounty.name
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: '/bounties/' + bounty.name
                                }, _toDisplayString(bounty.name), 9, _hoisted_10)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(bounty.reservedDate), 1),
                              _createElementVNode("td", null, _toDisplayString(bounty.status), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_icon, {
                                  onClick: ($event: any) => (_ctx.cancelBounty($event, bounty)),
                                  color: "error",
                                  icon: "mdi-cancel",
                                  style: {"cursor":"pointer","display":"inline-block"}
                                }, null, 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  color: "blue-grey-darken-4",
                  raised: "",
                  dark: "",
                  cover: "",
                  style: {"flex":"1","margin":"8px","padding":"5px","overflow":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Completed Bounties")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_table, { density: "compact" }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completedBounties, (bounty) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: bounty.name
                            }, [
                              _createElementVNode("td", null, _toDisplayString(bounty.name), 1),
                              _createElementVNode("td", null, _toDisplayString(bounty.completedDate), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_card, {
                color: "blue-grey-darken-4",
                raised: "",
                dark: "",
                cover: "",
                style: {"flex":"1","margin":"8px","padding":"5px","overflow-y":"hidden","height":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Available Bounties")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_text_field, {
                        "append-inner-icon": "mdi-magnify",
                        dense: "",
                        "hide-details": "",
                        "single-line": "",
                        variant: "solo",
                        density: "compact",
                        label: "Search",
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                        style: {"margin-bottom":"8px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_v_table, {
                      density: "compact",
                      style: {"flex":"1","overflow-y":"scroll"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterBounties(), (bounty) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: bounty.name
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: '/bounties/' + bounty.name
                                }, _toDisplayString(bounty.name), 9, _hoisted_15)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(bounty.price), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_dialog, {
                                  transition: "dialog-top-transition",
                                  width: "auto"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_tooltip, { text: "Reserve Bounty" }, {
                                      activator: _withCtx(({ props: tooltip }) => [
                                        _createVNode(_component_v_btn, _mergeProps(_ctx.mergeProps(props, tooltip), {
                                          color: "warning",
                                          icon: "mdi-lock",
                                          size: "x-small"
                                        }), null, 16)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(({ isActive }) => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_toolbar, {
                                          color: "primary",
                                          title: bounty.name + ' Bounty Request Form'
                                        }, null, 8, ["title"]),
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _hoisted_16,
                                            _createVNode(_component_v_text_field, {
                                              label: "Description",
                                              modelValue: _ctx.bountyRunDescription,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bountyRunDescription) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              variant: "text",
                                              onClick: ($event: any) => (isActive.value = false)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Cancel")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              variant: "text",
                                              onClick: ($event: any) => {isActive.value = false; _ctx.reserveBounty(bounty);}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Reserve")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}